(ns app.front.view.phase-event.subs
  (:require [app.front.entities :as entities]
            [app.front.view.phase-event.event :as event]
            [core.db.entity.util :as eu]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::workspace
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::entities/entity phase-id]))
  (fn [phase]
    (-> phase :entity/parent)))

(rf/reg-sub ::permit-type
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::workspace phase-id]))
  (fn [workspace]
    (-> workspace :workspace/permit-type)))

(rf/reg-sub ::workspace-events
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::workspace phase-id]))
  :-> event/entity->events)

(rf/reg-sub ::phase-children
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::entities/children phase-id]))
  (fn [children]
    children))

(rf/reg-sub ::phase-child-events
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::phase-children phase-id]))
  (fn [entities]
    (mapcat event/entity->events entities)))

(rf/reg-sub ::audit-events
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::workspace phase-id]))
  (fn [workspace]
    (->> workspace
         :entity/_parent
         (filter (eu/is-type-fn :entity.type/audit-event))
         (mapcat event/entity->events))))

(rf/reg-sub ::phase-events
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    [(rf/subscribe [::workspace-events phase-id])
     (rf/subscribe [::phase-child-events phase-id])
     (rf/subscribe [::audit-events phase-id])])
  (fn [events]
    (->> events
         (mapcat identity)
         (sort-by :time >))))

(rf/reg-sub ::event-count
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::phase-events phase-id]))
  :-> count)

(def initial-max-event-count 5)

(rf/reg-event-fx ::show-all-clicked
  (fn [{:keys [db]} [_ phase-id]]
    {:db (assoc db ::show-all phase-id)}))

(rf/reg-sub ::show-all?
  (fn [{::keys [show-all]} [_ phase-id]]
    {:pre [(integer? phase-id)]}
    (= phase-id show-all)))

(rf/reg-sub ::more-to-show?
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::event-count phase-id]))
  (fn [event-count]
    (< initial-max-event-count event-count)))

(rf/reg-sub ::visible-phase-events
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    [(rf/subscribe [::phase-events phase-id])
     (rf/subscribe [::show-all? phase-id])])
  (fn [[events show-all?]]
    (if show-all?
      events
      (take initial-max-event-count events))))

(rf/reg-sub ::has-phase-events?
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    (rf/subscribe [::phase-events phase-id]))
  (fn [events]
    (-> events seq boolean)))

(def enabled-permit-types #{:permit-type/CE :permit-type/PWO})

(rf/reg-sub ::show-phase-event-section?
  (fn [[_ phase-id]]
    {:pre [(integer? phase-id)]}
    [(rf/subscribe [::permit-type phase-id])
     (rf/subscribe [::entities/entity phase-id])])
  (fn [[permit-type phase]]
    ;; Minor optimization: generate event seq only for suitable permit types
    (and (enabled-permit-types permit-type)
         ;; Only display for authorities
         (-> phase :granted-permissions :permission.phase/authority-read)
         (<sub [::has-phase-events? (:db/id phase)]))))
